<template>
    <div class="fluid">
        <h1 class="app-title">Gerar Requisição</h1>
        <b-card>
            <b-row class="mb-0">
                <b-col class="mb-0">
                    <p class="mb-1 text-bold">
                        Escolha uma das opções abaixo correspondente à origem dos honorários:
                        <span class="text-danger">*</span>
                    </p>
                    <b-form-group label>
                        <b-form-radio-group
                                id="radio-group"
                                v-model="tipoRequisicao"
                                class="radio-filter">
                            <b-form-radio value="0">
                                1) Honorários de Protesto
                                <i class="fas fa-info-circle text-info fa-12x ml-3" variant="info"
                                   v-b-modal.modal-info-protesto
                                   v-b-popover.hover.top="'Clique aqui para saber mais sobre Honorários de Protesto'"></i>
                            </b-form-radio>
                            <b-form-radio value="1">
                                2) Honorários de Execução Fiscal D.A. SEFA
                                <i class="fas fa-info-circle text-info fa-12x ml-3" variant="info"
                                   v-b-modal.modal-info-ef-sefa
                                   v-b-popover.hover.top="'Clique aqui para saber mais sobre  Honorários de Execução Fiscal - Base de Cálculo e D.A. SEFA'"></i>
                            </b-form-radio>
                            <b-form-group label style="margin-left: 20px;" v-if="tipoRequisicao == 1">
                                <b-form-radio-group
                                        id="sub-radio-group"
                                        v-model="tipoRequisicaoSub"
                                        class="radio-filter">
                                    <b-form-radio value="0">
                                        Fluxo de geração de Requisição a partir do cálculo dos Honorários devidos
                                        <i class="fas fa-info-circle text-info fa-12x ml-3" variant="info"
                                           v-b-modal.modal-info-ef-sefa-requisicao
                                           v-b-popover.hover.top="'Clique aqui para saber mais sobre Fluxo de geração de Requisição a partir do cálculo dos Honorários devidos'"></i>
                                    </b-form-radio>
                                    <b-form-radio value="1">
                                        Fluxo de geração de Comunicação de Transferência de Honorários já realizada
                                        <i class="fas fa-info-circle text-info fa-12x ml-3" variant="info"
                                           v-b-modal.modal-info-ef-sefa-comunicacao
                                           v-b-popover.hover.top="'Clique aqui para saber mais sobre Fluxo de geração de Comunicação de Transferência de Honorários já realizada'"></i>
                                    </b-form-radio>
                                </b-form-radio-group>
                            </b-form-group>
                            <b-form-radio value="2">
                                3) Honorários de Ação Judicial
                                <i class="fas fa-info-circle text-info fa-12x ml-3" variant="info"
                                   v-b-modal.modal-info-acao-judicial
                                   v-b-popover.hover.top="'Clique aqui para saber mais sobre Honorários de Ação Judicial'"></i>
                            </b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                    <b-form-group label style="margin-left: 20px;" v-if="tipoRequisicao == 2">
                        <b-form-radio-group
                                id="sub-radio-group"
                                v-model="tipoRequisicaoSub"
                                class="radio-filter">
                            <b-form-radio value="0">
                                Fluxo de geração de Requisição a partir do cálculo dos Honorários devidos
                                <i class="fas fa-info-circle text-info fa-12x ml-3" variant="info"
                                   v-b-modal.modal-info-acao-judicial-requisicao
                                   v-b-popover.hover.top="'Clique aqui para saber mais sobre Fluxo de geração de Requisição a partir do cálculo dos Honorários devidos'"></i>
                            </b-form-radio>
                            <b-form-radio value="1">
                                Fluxo de geração de Comunicação de Transferência de Honorários já realizada
                                <i class="fas fa-info-circle text-info fa-12x ml-3" variant="info"
                                   v-b-modal.modal-info-acao-judicial-comunicacao
                                   v-b-popover.hover.top="'Clique aqui para saber mais sobre Fluxo de geração de Comunicação de Transferência de Honorários já realizada'"></i>
                            </b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <hr class="mt-2"/>
            <b-row class="right">
                <b-button variant="primary" class="ml-2" @click="iniciarRequisicao" id="btnIniciar">
                    Iniciar <i class="fas fa-arrow-right"></i>
                </b-button>
            </b-row>
        </b-card>
        <b-modal
                ref="modal-info-acao-judicial"
                id="modal-info-acao-judicial"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Honorários de Ação Judicial"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <ul>
                        <li>
                            <p>Essa funcionalidade permite <span style="font-weight: bold">gerar</span> e <span style="font-weight: bold">gerir</span> requisições de honorários de ação judicial ou de execução fiscal;</p>
                        </li>
                        <li>
                            <p>Para gerar requisições de honorários de execução fiscal de D.A. inscrita pela SEFA, utilize o serviço 2 acima.</p>
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info-acao-judicial')"> Fechar</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-info-acao-judicial-requisicao"
                id="modal-info-acao-judicial-requisicao"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Fluxo de geração de Requisição a partir do cálculo dos Honorários devidos"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <ul>
                        <li>
                            <p>Utilize este fluxo para calcular o valor de honorários de uma ação judicial ou de execução fiscal de D.A. não inscrita pela SEFA e gerar uma Requisição de Honorários para o processo e o correspondente boleto de pagamento;</p>
                        </li>
                        <li>
                            <p>Para fins de simples consulta ou apresentação do cálculo nos autos do processo, este fluxo permite ainda apenas calcular o valor de honorários de uma ação judicial ou de execução fiscal de D.A. não inscrita pela SEFA sem, ao final, gerar a Requisição (opção "Sair Sem Gerar Requisição" contida na penúltima tela do fluxo).</p>
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info-acao-judicial-requisicao')"> Fechar</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-info-acao-judicial-comunicacao"
                id="modal-info-acao-judicial-comunicacao"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Fluxo de geração de Comunicação de Transferência de Honorários já realizada"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <ul>
                        <li>
                            <p>Utilize este fluxo para gerar uma Comunicação de transferência de valor de honorários de determinada ação judicial ou de execução fiscal de D.A. não inscrita pela SEFA já realizada;</p>
                        </li>
                        <li>
                            <p>A Comunicação de transferência de honorários realizada para a conta do FEPGE será encaminhada ao Tesoureiro do FEPGE e ao GOFS para verificação do efetivo ingresso do valor informado na conta do FEPGE, dispensando a abertura de e-protocolo para essa finalidade. O acompanhamento da Comunicação pode ser feito através da aba Painel do Usuário;</p>
                        </li>
                        <li>
                            <p>A Comunicação de transferência de honorários realizada para a conta da CES será encaminhada à CES para registro.</p>
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info-acao-judicial-comunicacao')"> Fechar</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-info-ef-sefa"
                id="modal-info-ef-sefa"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Honorários de Execução Fiscal de D.A. inscrita pela SEFA"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <ul>
                        <li>
                            <p>Essa funcionalidade permite <span style="font-weight: bold">gerar</span> e <span style="font-weight: bold">gerir</span> requisições de honorários de execução fiscal de D.A. inscrita pela SEFA;</p>
                        </li>
                        <li>
                            <p>Para gerar requisições de honorários de execução fiscal de D.A. não inscrita pela SEFA ou de ação judicial, utilize o serviço 3 abaixo.</p>
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info-ef-sefa')"> Fechar</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-info-ef-sefa-requisicao"
                id="modal-info-ef-sefa-requisicao"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Fluxo de geração de Requisição a partir do cálculo dos Honorários devidos"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <ul>
                        <li>
                            <p>Utilize este fluxo para calcular o valor de honorários de uma execução fiscal D.A. SEFA e gerar uma Requisição de Honorários para a(s) CDA(s) ajuizada(s) selecionada(s) e o correspondente boleto de pagamento;</p>
                        </li>
                        <li>
                            <p>Para fins de simples consulta ou apresentação do cálculo nos autos do processo, este fluxo permite ainda apenas calcular o valor de honorários de uma execução fiscal D.A. SEFA sem, ao final, gerar a Requisição (opção "Sair Sem Gerar Requisição" contida na penúltima tela do fluxo).</p>
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info-ef-sefa-requisicao')"> Fechar</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-info-ef-sefa-comunicacao"
                id="modal-info-ef-sefa-comunicacao"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Fluxo de geração de Comunicação de Transferência de Honorários já realizada"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <ul>
                        <li>
                            <p>Utilize este fluxo para gerar uma Comunicação de transferência de valor de honorários de determinada execução fiscal D.A. SEFA já realizada;</p>
                        </li>
                        <li>
                            <p>A Comunicação de transferência de honorários realizada para a conta do FEPGE será encaminhada ao Tesoureiro do FEPGE e ao GOFS para verificação do efetivo ingresso do valor informado na conta do FEPGE, dispensando a abertura de e-protocolo para essa finalidade. O acompanhamento da Comunicação pode ser feito através da aba Painel do Usuário;</p>
                        </li>
                        <li>
                            <p>A Comunicação de transferência de honorários realizada para a conta da CES será encaminhada à CES para registro.</p>
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info-ef-sefa-comunicacao')"> Fechar</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-info-protesto"
                id="modal-info-protesto"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Honorários de Protesto"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <ul>
                        <li>
                            <p>Essa funcionalidade permite gerar e gerir requisições de horários de protesto.</p>
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info-protesto')"> Fechar</b-button>
            </template>
        </b-modal>
	    <b-modal
		    ref="modal-info-selic"
		    id="modal-info-selic"
		    size="xl"
		    :content-class="'shadow ' + getTheme"
		    title="Índice SELIC do mês anterior ainda não cadastrado no Sistema"
		    header-bg-variant="info"
		    header-text-variant="white">
		    <b-row class="mt-3">
			    <b-col xs="12" md="12" class="mx-auto">
				    <ul>
					    <li>
						    <p>A variação do índice SELIC do mês anterior ainda não foi cadastrada no Sistema.</p>
					    </li>
					    <li>
						    <p>Favor entrar em contato com a CGTI para o cadastro do índice.</p>
					    </li>
				    </ul>
			    </b-col>
		    </b-row>
		    <template v-slot:modal-footer="{ hide }">
			    <b-button variant="primary" @click="hide('modal-info-selic')"> Fechar</b-button>
		    </template>
	    </b-modal>
	    <CompLoading ref="loading"/>
    </div>
</template>
<script>
    import Multiselect from 'vue-multiselect'
    import axios from 'axios'
    import formatarMixins from '../../mixins/formatarMixins'
    import CompLoading from "../shared/components/CompLoading";

    export default {
        components: {Multiselect, CompLoading},
        mixins: [ formatarMixins ],
        data() {
            return {
	            urlApi: null,
	            token: null,
                tipoRequisicao: null,
                tipoRequisicaoSub: 0
            }
        },
        computed: {
            getTheme () {
                return this.$store.getters.getTheme
            }
        },
        methods: {
            iniciarRequisicao() {
	            this.$store.commit("setMessages", {});

                if(this.tipoRequisicao == null || (this.tipoRequisicao == 2 && this.tipoRequisicaoSub == null)
                    || (this.tipoRequisicao == 1 && this.tipoRequisicaoSub == null)) {
                    this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: [{
                            message: 'Escolha uma opção antes de Iniciar'
                        }]});
                    return;
                }

                if(this.tipoRequisicao == 0) {
                    this.$router.push({path: '/honorarios-protesto'});
                } else if(this.tipoRequisicao == 2 && this.tipoRequisicaoSub == 0) {
                    this.$router.push({path: '/honorarios-acao-judicial'});
                } else if(this.tipoRequisicao == 2 && this.tipoRequisicaoSub == 1) {
                    this.$router.push({path: '/comunicacao-transferencia'});
                } else if(this.tipoRequisicao == 1 && this.tipoRequisicaoSub == 0) {
	                this.$refs.loading.showLoading();
	                this.verificarSelicRequisicao('/honorarios-ef-sefa');
                } else if(this.tipoRequisicao == 1 && this.tipoRequisicaoSub == 1) {
	                this.$refs.loading.showLoading();
	                this.verificarSelicRequisicao('/comunicacao-transferencia-ef-sefa');
                }
            },
	        acionarEnter(e) {
		        if(e.key == 'Enter') {
			        if(this.$refs['modal-info-selic'].isShow) {
						this.hideModal('modal-info-selic');
			        } else {
				        document.getElementById("btnIniciar").click();
			        }
		        }
	        },
	        verificarSelicRequisicao(fluxo){
		        axios.get(`${this.urlApi}/v1/honorariosExecucaoFiscalSefa/verificarSelicAnterior`, {
			        headers: {
				        'Content-Type': 'application/json',
				        'Authorization': this.token
			        }
		        }).then(response => {
			        if(response.data) {
				        this.$router.push({path: fluxo});
			        } else {
				        this.showModal('modal-info-selic');
			        }
		        }).catch((error) => {
			        this.exibirErro(error)
		        }).finally(() => {
			        this.$refs.loading.hideLoading();
		        });
	        }
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

	        window.addEventListener("keypress", this.acionarEnter);
        },
        beforeDestroy() {
            window.removeEventListener('keypress', this.acionarEnter);
        },
    }
</script>